import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppSidebarMinimizer } from './app-sidebar-minimizer.component';
import { SidebarDirectiveModule }  from '../../../directives/sidebar/sidebar.module';
@NgModule({
  declarations: [
    AppSidebarMinimizer
  ],
  imports: [
    BrowserModule,
    SidebarDirectiveModule
  ],
  exports: [
    AppSidebarMinimizer
  ]
})
export class AppSidebarMinimizerModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/app-sidebar/app-sidebar-minimizer/app-sidebar-minimizer.module.ts